import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { useForm, Controller } from "react-hook-form";

// Material-UI
import {
  Container,
  Grid,
  makeStyles,
  Paper,
  Typography,
  TextField,
  Button,
  Box,
} from "@material-ui/core";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Alert from "@material-ui/lab/Alert";
import AlertTitle from "@material-ui/lab/AlertTitle";
// Components
import Navbar from "../components/NavbarTitle";
import Background from "../components/BackgroundPattern";
import Footer from "../components/Footer";
// import CetakBerkasPendaftaran from '../components/CetakBerkasPendaftaran';

//service
import uploadService from '../services/uploadService';
import userService from '../services/userService';

const useStyle = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh"
  },
  info: {
    margin: theme.spacing(2),
    "& .MuiAlert-icon": {
      fontSize: 40,
      padding: theme.spacing(1),
      margin: theme.spacing(2),
      [theme.breakpoints.down("xs")]: {
        fontSize: 30,
        paddingTop: 30,
        margin: theme.spacing(1),
      },
    },
    minHeight: 150,
  },
  paper: {
    margin: theme.spacing(4, 2),
    padding: theme.spacing(4, 2),
  },
  submit: {
    margin: theme.spacing(2, 0),
  },
  unduh: {
    margin: theme.spacing(2, 0),
  },
  link: {
    textDecoration: "none",
    color: "#ff1447",
    width: "inherit"
  },
  input: {
    width: "-webkit-fill-available",
    margin: theme.spacing(1, 0),
    padding: theme.spacing(2),
    border: "1px solid rgb(133, 133, 133)",
    borderRadius: "5px"
  },
  formInput: {
    paddingTop: "0px !important",
    paddingBottom: "0px !important"
  },
  title: {
    color: theme.palette.black.main,
    fontWeight: "bold"
  }
}));

const CardInfoBerkas = ({ classes }) => {
  return (
    <section id="card-info">
      <Grid container>
        <Grid item xs={12} sm={12} md={6}>
          <Alert variant="filled" severity="success" className={classes.info} elevation={3}>
            <AlertTitle style={{ paddingTop: 15 }}>
              {"Selamat datang pada "}
              <strong>
                {
                  "Sistem Informasi Penerimaan Calon Anggota Baru (PCAB) KSR PMI Unit UNJ."
                }
              </strong>
            </AlertTitle>
          </Alert>
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <Alert variant="filled" severity="warning" className={classes.info} elevation={3}>
            <AlertTitle style={{ paddingTop: 15 }}>
              <strong>{"Siapkan Foto 3 x 4 (ukuran maksimal 1 MB) "}</strong>
              {
                " dan silahkan masukkan identitas (nama, nomor hp, alamat) orang tua / wali untuk keperluan surat izin mengikuti kegiatan PCAB KSR PMI Unit UNJ."
              }
            </AlertTitle>
          </Alert>
        </Grid>
      </Grid>
    </section>
  );
};

const FormBiodata = ({ classes }) => {
  const { register, handleSubmit, control } = useForm();

  // OpenButtonHandle
  const [openButton, setOpenButton] = useState(false)
  const onSubmit = (data) => {
    let id_user = localStorage.getItem('id_user') || '';
    let date = new Date();
    const formData = new FormData();

    formData.append('noreg', data.nomorRegistrasi);
    formData.append('nama_lengkap', data.namaLengkap);
    formData.append('tanggal_lahir', data.tanggalLahir);
    formData.append('tempat_lahir', data.tempatLahir);
    formData.append('jenis_kelamin', data.jenisKelamin);
    formData.append('alamat_ktp', data.alamatKTP);
    formData.append('alamat_sekarang', data.alamatSekarang);
    formData.append('golongan_darah', data.golonganDarah);
    formData.append('agama', data.agama);
    formData.append('fakultas', data.fakultas);
    formData.append('prodi', data.prodi);
    formData.append('angkatan', data.angkatan);
    formData.append('nomor_hp', data.nomorHp);
    formData.append('riwayat_penyakit', data.riwayatPenyakit);
    formData.append('nama_orangtua', data.namaOrangTua)
    formData.append('alamat_orangtua', data.alamatOrangTua);
    formData.append('nohp_orangtua', data.nomorOrangTua);
    formData.append('nohp_orangdekat', data.nomorDarurat);
    formData.append('file_foto', data.fotoBiodata[0]);
    formData.append('id_user', id_user);
    formData.append('tahun_daftar', date.getFullYear());
    
    uploadService.biodata(formData)
    .then(response => {
      return (
        Swal.fire({
          icon: "success",
          title: "Data Berhasil Disimpan!",
          text: "Silahkan unduh berkas pendaftaran ^_^",
        }), setOpenButton(!openButton)
      )
    })
    .catch(err => {
      console.log(err);
      return (
        Swal.fire({
          icon: "error",
          title: "Data Gagal Disimpan!",
          text: "Silakan hubungi kami melalui WhatsApp",
        })
      )
    })

  };
  
  return (
    <section id="form-biodata">
      <Paper elevation={5} className={classes.paper}>
        <Container>
          <Box mb={3}>
            <Typography variant="h5" className={classes.title} gutterBottom>
              {"Berkas Pendaftaran"}
            </Typography>
          </Box>
          <form onSubmit={handleSubmit(onSubmit)} noValidate autoComplete="off">
            <Grid container spacing={1}>
              {/* 1. Biodata Diri */}
              <Grid item xs={12}>
                <Box mb={-1}>
                  <Typography variant="h6" className={classes.title}>
                    {"1. Biodata Diri"}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12} >
                <input
                  id="fotoBiodata"
                  name="fotoBiodata"
                  ref={register({ required: true })}
                  type="file"
                  accept="image/png, image/jpeg"
                  className={classes.input}
                  required
                />
                <Typography variant="caption" align="center" color="primary">
                  {"Unggah Foto 3 x 4 (ukuran maksimal 1MB)"}
                </Typography>
              </Grid>
              <Grid item xs={12} className={classes.formInput}>
                <TextField
                  id="namaLengkap"
                  name="namaLengkap"
                  inputRef={register({ required: true })}
                  label="Nama Lengkap"
                  type="text"
                  variant="outlined"
                  margin="normal"
                  placeholder="Nama Lengkap Kamu"
                  required
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} className={classes.formInput}>
                <TextField
                  id="tempatLahir"
                  name="tempatLahir"
                  inputRef={register({ required: true })}
                  label="Tempat Lahir"
                  type="text"
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} className={classes.formInput}>
                <TextField
                  id="tanggalLahir"
                  name="tanggalLahir"
                  inputRef={register({ required: true })}
                  type="date"
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} className={classes.formInput}>
                <FormControl
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                >
                  <InputLabel id="jenisKelaminLabel">
                    {"Jenis Kelamin"}
                  </InputLabel>
                  <Controller
                    as={
                      <Select
                        labelId="jenisKelaminLabel"
                        id="jenisKelamin"
                        label="Jenis Kelamin"
                      >
                        <MenuItem value="" disabled>
                          <em>Pilih Jenis Kelamin</em>
                        </MenuItem>
                        <MenuItem value="L">{"Pria"}</MenuItem>
                        <MenuItem value="P">{"Wanita"}</MenuItem>
                      </Select>
                    }
                    name="jenisKelamin"
                    control={control}
                    defaultValue=""
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={6} className={classes.formInput}>
                <TextField
                  id="alamatKTP"
                  name="alamatKTP"
                  inputRef={register({ required: true })}
                  label="Alamat KTP"
                  type="text"
                  variant="outlined"
                  margin="normal"
                  placeholder="Jl. Pemuda Rawamangun RT.009/08 NO.12"
                  required
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} className={classes.formInput}>
                <TextField
                  id="alamatSekarang"
                  name="alamatSekarang"
                  inputRef={register({ required: true })}
                  label="Alamat Tinggal Sekarang"
                  type="text"
                  variant="outlined"
                  margin="normal"
                  placeholder="Jl. Pemuda Rawamangun RT.009/08 NO.12"
                  required
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} className={classes.formInput}>
                <TextField
                  id="agama"
                  name="agama"
                  inputRef={register({ required: true })}
                  label="Agama"
                  type="text"
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} className={classes.formInput}>
                <FormControl
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                >
                  <InputLabel id="golonganDarahLabel">
                    {"Golongan Darah"}
                  </InputLabel>
                    <Controller
                      as={
                        <Select
                          labelId="golonganDarahLabel"
                          id="golonganDarah"
                          label="Golongan Darah"
                        >
                          <MenuItem value="">
                            <em>{"Pilih Golongan Darah Kamu"}</em>
                          </MenuItem>
                          <MenuItem value="A">A</MenuItem>
                          <MenuItem value="B">B</MenuItem>
                          <MenuItem value="AB">AB</MenuItem>
                          <MenuItem value="O">O</MenuItem>
                        </Select>
                        }
                        name="golonganDarah"
                        control={control}
                        defaultValue=""
                    />
                </FormControl>
              </Grid>
              <Grid item xs={12} className={classes.formInput}>
                <TextField
                  id="riwayatPenyakit"
                  name="riwayatPenyakit"
                  inputRef={register({ required: true })}
                  label="Riwayat Penyakit"
                  type="text"
                  variant="outlined"
                  margin="normal"
                  placeholder="Tidak Ada / Sebutkan Nama Penyakit Kamu"
                  required
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} className={classes.formInput}>
                <TextField
                  id="nomorHp"
                  name="nomorHp"
                  inputRef={register({ required: true })}
                  label="Nomor Handphone (HP)"
                  type="number"
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} className={classes.formInput}>
                <TextField
                  id="nomorDarurat"
                  name="nomorDarurat"
                  inputRef={register({ required: true })}
                  label="Nomor HP yang dapat dihubungi saat Darurat"
                  type="number"
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                />
              </Grid>

              {/* 2. Data Kuliah */}
              <Grid item xs={12}>
                <Box mt={3} mb={-1}>
                  <Typography variant="h6" className={classes.title}>
                    {"2. Data Kuliah"}
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={12}>
                <TextField
                  id="nomorRegistrasi"
                  name="nomorRegistrasi"
                  inputRef={register({ required: true, min: 10 })}
                  label="Nomor Registrasi (NIM)"
                  type="number"
                  variant="outlined"
                  margin="normal"
                  placeholder="cotoh: 5235160182"
                  required
                  fullWidth
                />
                <TextField
                  id="fakultas"
                  name="fakultas"
                  inputRef={register({ required: true })}
                  label="Fakultas"
                  type="text"
                  variant="outlined"
                  margin="normal"
                  placeholder="contoh: FT, FIP, FIK"
                  required
                  fullWidth
                />
                <TextField
                  id="prodi"
                  name="prodi"
                  inputRef={register({ required: true })}
                  label="Program Studi"
                  type="text"
                  variant="outlined"
                  margin="normal"
                  placeholder="contoh: Pendidikan Teknik Informatika dan Komputer"
                  required
                  fullWidth
                />
                <TextField
                  id="angkatan"
                  name="angkatan"
                  inputRef={register({ required: true })}
                  label="Tahun Masuk"
                  type="number"
                  variant="outlined"
                  margin="normal"
                  placeholder="contoh: 2016"
                  required
                  fullWidth
                />
              </Grid>

              {/* 3. Data Orang Tua / Wali */}
               <Grid item xs={12}>
                <Box mt={3} mb={-1}>
                  <Typography variant="h6" className={classes.title}>
                    {"3. Data Orang Tua / Wali"}
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={12}>
                <TextField
                  id="namaOrangTua"
                  name="namaOrangTua"
                  inputRef={register({ required: true })}
                  label="Nama Orang Tua / Wali"
                  type="text"
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                />
                <TextField
                  id="alamatOrangTua"
                  name="alamatOrangTua"
                  inputRef={register({ required: true })}
                  label="Alamat Orang Tua / Wali"
                  type="text"
                  variant="outlined"
                  margin="normal"
                  placeholder="Jl. Pemuda Rawamangun RT.009/08 NO.12"
                  required
                  fullWidth
                />
                <TextField
                  id="nomorOrangTua"
                  name="nomorOrangTua"
                  inputRef={register({ required: true })}
                  label="Nomor HP Orang Tua / Wali"
                  type="number"
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                />
              </Grid>
            </Grid>

            <Grid container spacing={2}>
              
              <Grid item xs={12} sm={12} md={6} className={classes.submit}>
                <FormControlLabel
                  value="true"
                  control={<Checkbox color="primary" />}
                  label={
                    <Typography variant="body1">
                      {
                        "Dengan ini saya menyatakan bahwa data yang saya berikan adalah benar dan dapat digunakan untuk keperluan organisasi"
                      }
                    </Typography>
                  }
                  labelPlacement="end"
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} className={classes.submit}>
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  type="submit"
                  fullWidth
                >
                  {"Submit"}
                </Button>
              </Grid>
            </Grid>
          </form>
        </Container>
      </Paper>

      <section id="unduh-berkas">
        <Paper elevation={5} className={classes.paper}>
          <Container>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={6}>
                <Typography variant="body1" gutterBottom>
                  <strong>{"Berikut berkas pendaftaran yang diunduh :"}</strong>
                </Typography>
                <Typography variant="body2" gutterBottom>
                  {"1. Formulir Pendaftaran"}
                </Typography>
                <Typography variant="body2" gutterBottom>
                  {"2. Surat Izin Orang Tua"}
                </Typography>
                <Typography variant="body2" gutterBottom>
                  {"3. Surat Komitmen"}
                </Typography>
                <Typography variant="body1" gutterBottom>
                  <strong>
                    {
                      "Setelah mengunduh berkas pendaftaran, silahkan klik tombol Selanjutnya untuk proses unggah berkas pendaftaran"
                    }
                  </strong>
                </Typography>
              </Grid>
              <Grid item xs={12} sm={12} md={6}>
                <Button
                  href="/doc/Berkas_Pendaftaran_PCAB.pdf"
                  target="_blank"
                  className={classes.unduh}
                  variant="contained"
                  color="primary"
                  type="submit"
                  size="large"
                  fullWidth
                  disabled={!openButton}
                >
                {"Unduh Berkas Pendaftaran"}
                </Button>
                <Button
                  className={classes.unduh}
                  href="/user/validasi-berkas"
                  variant="outlined"
                  color="primary"
                  type="submit"
                  size="large"
                  fullWidth
                  disabled={!openButton}
                  >
                    {"Selanjutnya"}
                </Button>
              </Grid>
            </Grid>
          </Container>
        </Paper>
      </section>
    </section>
  );
};

const ValidasiBiodata = () => {
  const classes = useStyle();

  useEffect(() => {
    userService.getUserInfo()
    .then((response) => {
      localStorage.setItem('tahap', response.data.tahap);
    })
    .catch(e => {
      console.log(e)
      return (
        window.location.reload()
      )
    })
  }, []);

  return (
    <section id="validasi-biodata" className={classes.container}>
      <Background/>
      <Navbar title="VALIDASI BERKAS PENDAFTARAN" />
        <Container style={{flex: "1"}}>
          <CardInfoBerkas classes={classes} />
            <FormBiodata classes={classes} />
        </Container>
      <Footer />
    </section>
  );
};

export default ValidasiBiodata;
